import getters from '@/store/modules/getters'
import mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

mutations.D0104_OTHER_LIST = function (state, payload) {
  state.d0104OtherList = payload
}
mutations.D0102_RELATE_LIST = function (state, payload) {
  state.d0102RelateList = payload
}

const state = {
  rows: [],
  row: null,
  condition: {where: {}, andOr: 'AND'},
  d0102RelateList: []
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        relate: { api: 'D0102RelateService.getDataForListbox' },
        other: { api: 'D0104OtherService.getDataForListbox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('D0102_RELATE_LIST', data.relate.output)
        commit('D0104_OTHER_LIST', data.other.output)
      })
  },
  search: ({ commit, state }, condition) => {
    console.debug('called D0101Demo search')
    return client.postData({ data: { search: { api: 'D0101DemoService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called D0101Demo add')
    commit('EDIT',
      {
        id: null,
        files: {},
        relates: {},
        belongs: {}
      }
    )
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called D0101Demo cancel')
    commit('EDIT', null)
  },
  edit: ({ commit, state }, id) => {
    console.debug('called D0101Demo edit')
    return client.postData({ data: { find: { api: 'D0101DemoService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called D0101Demo delete')
    return client.postData({ data: { delete: { api: 'D0101DemoService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called D0101Demo save')
    return client.postData({ data: { save: { api: 'D0101DemoService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  pdf: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'D0101DemoService.exportPdf', input: condition } } })
  },
  excel: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'D0101DemoService.exportExcel', input: condition } } })
  },
  csv: ({ commit, state }, condition) => {
    return client.download({ data: { download: { api: 'D0101DemoService.exportCsv', input: condition } } })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
